import { useState, useRef, useEffect } from "react";
import "./DesktopMenu.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { ROUTE_ENUM, SVG_ENUM, ROLES_ENUM } from "enums";
import { SVG } from "shared";
import { UserType } from "types/UsersTypes";
import { useLogout } from "hooks/auth";
import { clearSessionStorage } from "utils";

interface DesktopMenuType {
  user: UserType | undefined;
}

const DesktopMenu = ({ user }: DesktopMenuType) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navigationRef = useRef<HTMLElement | null>(null);
  const { mutate: logout } = useLogout({});
  const isAdmin = user?.role === ROLES_ENUM.ADMIN;
  const navigate = useNavigate();

  useEffect(() => {
    const navigationNode = navigationRef.current;

    if (navigationNode) {
      const handleMouseEnter = () => setIsNavOpen(true);
      const handleMouseLeave = () => setIsNavOpen(false);

      navigationNode.addEventListener("mouseenter", handleMouseEnter);
      navigationNode.addEventListener("mouseleave", handleMouseLeave);

      return () => {
        navigationNode.removeEventListener("mouseenter", handleMouseEnter);
        navigationNode.removeEventListener("mouseleave", handleMouseLeave);
      };
    }
  }, [navigationRef]);

  const handleLogout = () => {
    logout();
  };

  const handleOnClick = () => {
    clearSessionStorage();
  };

  const handleClickLogo = () => {
    navigate(`${ROUTE_ENUM.COMPANIES}`);
    setIsNavOpen(false);
  };

  return (
    <>
      <nav
        ref={navigationRef}
        className={`desktop-menu ${isNavOpen ? "desktop-menu--open" : ""}`}
      >
        <div
          className="desktop-menu-item desktop-menu__logo"
          onClick={() => handleClickLogo()}
        >
          <SVG type={SVG_ENUM.RELIANCE} />
        </div>
        {isAdmin ? (
          <>
            <NavLink
              to={`${ROUTE_ENUM.COMPANIES}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.LIST_UNORDERED} />
              <div className="desktop-menu-item__name">Spółki</div>
            </NavLink>
            <NavLink
              to={`${ROUTE_ENUM.MARKET_INFORMATION}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.ANNOUCEMENT} />
              <div className="desktop-menu-item__name">Informacje</div>
            </NavLink>
            <NavLink
              to={`${ROUTE_ENUM.ANALYSIS}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.PRESENTATION} />
              <div className="desktop-menu-item__name">Analizy</div>
            </NavLink>
            <NavLink
              to={`${ROUTE_ENUM.USERS}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.USER_GROUP} />
              <div className="desktop-menu-item__name">Użytkownicy</div>
            </NavLink>
          </>
        ) : (
          <>
            <NavLink
              to={`${ROUTE_ENUM.COMPANIES}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.LIST_UNORDERED} />
              <div className="desktop-menu-item__name">Spółki</div>
            </NavLink>
            <NavLink
              to={`${ROUTE_ENUM.MARKET_INFORMATION}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.ANNOUCEMENT} />
              <div className="desktop-menu-item__name">Informacje</div>
            </NavLink>
            <NavLink
              to={`${ROUTE_ENUM.ANALYSIS}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.PRESENTATION} />
              <div className="desktop-menu-item__name">Analizy</div>
            </NavLink>
            <NavLink
              to={`${ROUTE_ENUM.SUCCESSOR}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.SUCCESSOR} />
              <div className="desktop-menu-item__name">Sukcesja</div>
            </NavLink>
            <NavLink
              to={`${ROUTE_ENUM.CONTACT}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.MESSAGE_DOT_CIRCLE} />
              <div className="desktop-menu-item__name">Kontakt i wsparcie</div>
            </NavLink>
            <NavLink
              to={`${ROUTE_ENUM.PROFILE}`}
              className="desktop-menu-item"
              onClick={handleOnClick}
            >
              <SVG type={SVG_ENUM.USER} />
              <div className="desktop-menu-item__name">Profil</div>
            </NavLink>
          </>
        )}

        <div
          onClick={() => handleLogout()}
          className={`desktop-menu-item desktop-menu-item--employee-logout`}
        >
          <SVG type={SVG_ENUM.LOGOUT} />
          <div className="desktop-menu-item__name">Wyloguj się</div>
        </div>
      </nav>
    </>
  );
};

export default DesktopMenu;
